import { render, staticRenderFns } from "./ConsentsForm.vue?vue&type=template&id=c8c1feda"
import script from "./ConsentsForm.vue?vue&type=script&lang=js"
export * from "./ConsentsForm.vue?vue&type=script&lang=js"
import style0 from "./ConsentsForm.vue?vue&type=style&index=0&id=c8c1feda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports